import { z } from 'zod';
export const googleAuthCallbackSchema = z.object({
    code: z.string().min(1, 'Authorization code is required'),
});
export const refreshTokenSchema = z.object({
    refreshToken: z.string().min(1, 'Refresh token is required'),
});
//# sourceMappingURL=auth.js.map